<template>
	<div class="canvas-opened">
		<div class="dark-mark"></div>
		<div class="firstlogin-box fadeInDown animated">
			<img src="../assets/imgs/login/login-success.png" style="width: 3rem;height: 3rem;margin-bottom: 1rem;">
			<div class="firstlogin-title">Successfull!</div>
			<div class="firstlogin-desc">In order to provide better services, please complete the following information first</div>
			
			<div v-if="nationdata">
				<!-- 选择性别 -->
				<div style="" class="login-input-box" style="position: relative;">
					<span class="login-input-box-text">gender</span>
					<!-- <input type="text" class="login-input" placeholder="" v-model="nation" @click="nationbox=1"> -->
					<div class="login-input" style="height: 2.5rem;display: flex;align-items: center;cursor: pointer;" @click="genderbox=!genderbox;tagsbox=false;nationbox=false">
						<span v-if="!gender" style="color: #ccc;">please choose</span><span v-else>{{gender.name}}</span>
					</div>
					<div style="" class="sel-box" v-show="genderbox">
						<div v-for="(item, index4) in genderlist" :key="index4" class="sel-box-list" @click="changegender(item)"><span style="flex: 1;">{{item.name}}</span></div>
					</div>
				</div>
				<!-- 选择国家 -->
				<div style="" class="login-input-box" style="position: relative;">
					<span class="login-input-box-text">Nation</span>
					<!-- <input type="text" class="login-input" placeholder="" v-model="nation" @click="nationbox=1"> -->
					<div class="login-input" style="height: 2.5rem;display: flex;align-items: center;cursor: pointer;" @click="nationbox=!nationbox;tagsbox=false;genderbox=false"><span v-if="!nation" style="color: #ccc;">please choose</span>{{nation}}</div>
					<div style="" class="sel-box" v-show="nationbox">
						<div v-for="(item, index) in nationdata.items" :key="index" class="sel-box-list" @click="changenation(item)"><span style="flex: 1;">{{item.englishName}}</span></div>
					</div>
				</div>
				<!-- 选择标签 -->
				<div style="" class="login-input-box" style="position: relative;">
					<div style="display: flex;align-items: center;">
						<span style="flex: 1;" class="login-input-box-text">Interest tags</span>
						<span style="font-size: 0.7rem;color: #666;">less than 5</span>
					</div>
					<!-- <input type="text" class="login-input" placeholder="Choose tags" v-model="tags" style="width: 21rem;"> -->
					<div class="login-input" style="min-height: 2.5rem;display: flex;align-items: center;cursor: pointer;" @click="tagsbox=!tagsbox;nationbox=false;genderbox=false">
						<!-- <span v-if="tags.length==0">tags</span> -->
						<div style="min-width: calc(100% - 1.5rem);max-width: calc(100% - 1.5rem);" class="wrapper" ref="wrapper">
							<div v-if="tags.length==0" style="color: #ccc;">please choose</div>
							<div v-for="(tag, index3) in tags" :key="index3" class="wrapper-content"
									style="background-color: #F7F8FA;margin-right: 0.2rem;margin-bottom: 0.2rem;">
								{{tag.name}}
								<img src="../../src/assets/imgs/close-tag.png" style="width: 1rem;height: 1rem;" @click.stop="closetag(tag.id)">
							</div>
						</div>
						<div style="margin-left: 0.5rem;">
							<img src="../../src/assets/imgs/user/add.svg" style="width: 1rem;height: 1rem;cursor: pointer;">
						</div>
					</div>
					<div style="" class="sel-box" v-show="tagsbox">
						<div v-for="(item, index2) in tagsdata" :key="index2" class="sel-box-list" @click="changetags(item)" v-show="tags.findIndex(key => key.id==item.id )==-1">
							<span style="flex: 1;">{{item.label}}</span>
						</div>
					</div>
				</div>
				<div style="margin-top: 1rem;display: flex;align-items: center;justify-content: center;">
					<div class="login-button" @click="saveinfo()" style="flex: 1"
							:class="{'login-btn-active':tags.length>0&&nationid}">
						Save
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
		import Drag from '../utils/move.js'
		export default {
			data() {
				return {
					nationbox:false,
					tagsbox:false,
					nationdata:null,
					nation:'',
					nationid: '',
					industrydata:null,
					industry:'',
					tagsdata:null,
					tags:[],
					
					genderlist:[{
						name:'secrecy',
						value:1
					},{
						name:'man',
						value:2
					},{
						name:'woman',
						value:3
					}],
					gender:null,
					genderbox:false
				}
			},
			props:{
				// img:String
			},
			components: {
			},
			filters: {
	        },
			methods: {
				saveinfo(){
					// console.info(this.tags)
					// console.info(this.nationid)
					if(this.nationid&&this.tags.length>0&&this.gender){
						let tagIds = ''
						for (let i in this.tags) {
							tagIds += this.tags[i].id+','
						}
						// tagIds.slice(1,-1)
						tagIds = tagIds.substring(0, tagIds.length - 1);
						let params = {
							tagIds: tagIds,
							countryId: this.nationid,
							sex: this.gender.value
						}
						this.request({
							method: 'post',
							url: '/gci/user/update',
							data:params
						}).then(res => {
							if(res.status==0){
								this.$bus.$emit('firstlogin', false)
								// location.reload();
							}else{
								// alert(res.msg)
								this.$bus.$emit('message', {
									type:3,
									msg:res.msg
								})
							}
						}).catch(error => {
							console.error(error.response)
						})
					}else{
						this.$bus.$emit('message',{
							type:1,
							msg:'Please select a gender and country and tags'
						})
					}
				},
				closetag(id){
					for (let i in this.tags) {
						if(this.tags[i].id==id){
							this.tags.splice(i, 1)
						}
					}
					this.tagsbox=false
				},
				changetags(obj){
					if(this.tags.length<5){
						this.tags.push(obj)
						this.tagsbox = 0
					}else{
						// alert('Select up to 5 tags')
						this.$bus.$emit('message',{
							type:1,
							msg:'Select up to 5 tags'
						})
					}
				},
				changenation(obj){
					this.nation = obj.englishName
					this.nationid = obj.id
					this.nationbox = false
				},
				changegender(obj){
					this.gender = obj
					this.genderbox = false
				},
				getnationdata(){
					this.request({
						method: 'get',
						url: '/gci/country/list',
					}).then(res => {
						this.nationdata = res.data
					}).catch(error => {
						console.error(error.response)
					})
				},
				gettagsdata(){
					this.request({
						method: 'get',
						url: '/gci/tag',
					}).then(res => {
						this.tagsdata = res.data
						new Drag(this.$refs.wrapper);
					}).catch(error => {
						console.error(error.response)
					})
				},
				close() {
					this.$bus.$emit('firstlogin', false)
				},
			},
			mounted() {
				this.getnationdata()
				this.gettagsdata()
			}
		}
</script>

<style lang="scss" scoped>
	.firstlogin-box{
		margin: auto;
		position: fixed;
		top: 0; left: 0; bottom: 0; right: 0;
		width:25rem;height: fit-content;
		border-radius: 1rem;
		padding: 2rem;
		background-color: #fff;
		z-index: 999;
		display: flex;flex-direction: column;align-items: center;
		
		.firstlogin-title{
			font-size: 1.5rem;font-weight: bold;margin-bottom: 1rem;
		}
		.firstlogin-desc{
			font-size: 0.7rem;text-align: center;font-weight: 500;
		}
	}
	.dark-mark{
		z-index: 999;
		background-color: rgba(0, 0, 0, 0.5);
	}
	.login-title{
		font-size: 1.5rem;color: #333;font-weight: bold;text-align: center;
	}
	.login-input-box{
		margin-top: 1rem !important;
		display: flex;flex-direction: column;
		.login-input-box-text{
			color: #333;font-weight: 500;font-size: 0.9rem;
		}
		.login-input{
			border: 1px solid #eee;padding: 0.5rem;margin-top: 0.5rem;border-radius: 0.2rem;width: 20rem;font-size: 0.9rem;
		}
	}
	.login-button{
		border-radius: 0.2rem;color: #333;font-size: 1rem;font-weight: bold;background: #f3f3f3;
		width: 12rem;height: 2.5rem;display: flex;align-items: center;justify-content: center;
	}
	
	
	.sel-box-list:hover{
		background-color: #31ffda;
	}
	.sel-box{
		width: 20rem;height: fit-content;position: absolute;background-color: #fff;border: 1px solid #000;left: 0;top: 4.5rem;overflow: scroll;z-index: 20;max-height: 10rem;
		.sel-box-list{
			display: flex;
			padding: 0 1rem;
		}
	}
	.sel-box::-webkit-scrollbar {display:none}
	.login-btn-active{
		background:linear-gradient(90deg, #4EDFD2 0%, #92FBF2 100%);
		cursor: pointer;
	}
	@media (min-width:767px) {
		.login-input:hover{
				border:1px solid #000 !important
		}
	}
	@media (max-width:767px) {
		.firstlogin-box{
			width: 90vw;
		}
	}
</style>